<template>
    <div
        class="karteikarte"
        :class="{ active: isActive }"
        @click="isActive = !isActive"
    >
        <div class="front">
            <h1>{{ title }}</h1>
        </div>
        <div class="back">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'karteikarte',
    props: {
        title: {
            type: String,
            required: true,
        },
        isActive: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style scoped lang="sass">
.karteikarte
    width: 100%
    border-radius: 10px
    border-width: 1px
    border-style: solid
    height: 250px
    padding: 10px
    position: relative
    cursor: pointer
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
    transform-style: preserve-3d
    transition: all 0.75s ease-in-out
    background: white

    &.active
        transform: rotateY(180deg)

    .front,
    .back > *
        top: 50%
        transform: translate(-50%, -50%)
        left: 50%

    .front,
    .back,
    .back > *
        position: absolute
        text-align: center
        backface-visibility: hidden

.back
    transform: rotateY(180deg)
    overflow: auto
    height: 90%
    width: 90%
    left: 5%
    font-size: x-large

    > *
        width: 100%
        height: 100%
</style>
